import { useAuthStore } from '@/stores/authStore'

// Firebase ID tokens expire after 1 hour; refresh every 50 minutes
const REFRESH_INTERVAL_MS = 50 * 60 * 1000

export const startTokenRefresh = (): ReturnType<typeof setInterval> => {
  return setInterval(() => {
    const { isAuthenticated, refreshToken } = useAuthStore.getState()
    if (isAuthenticated) {
      refreshToken()
    }
  }, REFRESH_INTERVAL_MS)
}
